import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { getSettings } from '../../services/api';

const AboutContainer = styled.div`
  padding: 2rem;
  direction: rtl;
`;

const Title = styled.h1`
  color: #8B0000;
  text-align: center;
  margin-bottom: 2rem;
  font-size: 2.5rem;
`;

const Content = styled.div`
  max-width: 800px;
  margin: 0 auto;
  line-height: 1.8;
  font-size: 1.1rem;
`;

const Section = styled.section`
  margin-bottom: 2rem;
`;

const SectionTitle = styled.h2`
  color: #3f0101;
  margin-bottom: 1rem;
  font-size: 1.8rem;
`;

const Paragraph = styled.p`
  white-space: pre-wrap;
`;

const defaultAbout = {
  about_history:
    'تأسست كنيسة الأنبا بولا في عام ١٩٩٥، وهي تخدم المجتمع القبطي في المنطقة منذ ذلك الحين. ' +
    'الكنيسة مكرسة على اسم القديس العظيم الأنبا بولا، أول السواح.',
  about_mission:
    'نسعى لنشر تعاليم المسيح وخدمة المجتمع من خلال التعليم الروحي والخدمات الاجتماعية. ' +
    'نؤمن بأهمية بناء مجتمع مسيحي قوي يعيش وفقاً لتعاليم الإنجيل.',
  about_values:
    'نؤمن بالمحبة والخدمة والتواضع كقيم أساسية في حياتنا المسيحية. ' +
    'نسعى لتقديم القدوة الحسنة من خلال السلوك المسيحي والخدمة المتفانية.',
};

const About: React.FC = () => {
  const [about, setAbout] = useState(defaultAbout);

  useEffect(() => {
    getSettings()
      .then(res => setAbout(prev => ({
        about_history: res.data.about_history || prev.about_history,
        about_mission: res.data.about_mission || prev.about_mission,
        about_values: res.data.about_values || prev.about_values,
      })))
      .catch(() => {});
  }, []);

  return (
    <AboutContainer>
      <Title>عن كنيستنا</Title>
      <Content>
        <Section>
          <SectionTitle>تاريخ الكنيسة</SectionTitle>
          <Paragraph>{about.about_history}</Paragraph>
        </Section>

        <Section>
          <SectionTitle>رسالتنا</SectionTitle>
          <Paragraph>{about.about_mission}</Paragraph>
        </Section>

        <Section>
          <SectionTitle>قيمنا</SectionTitle>
          <Paragraph>{about.about_values}</Paragraph>
        </Section>
      </Content>
    </AboutContainer>
  );
};

export default About;
